<payee-popup title="Díjak szerkesztése">
  <div class="case-info">
    <p>Iktatószám: {{ data.payee_case_reference_id }}</p>
  </div>

  @if (!loading()) {
    <div class="fee-layout">
      <div class="fee-list">
        @for (fee of fees(); track fee.uuid) {
          <button
            type="button"
            class="fee-list-item"
            [class.selected]="selectedFee()?.uuid === fee.uuid"
            (click)="selectFee(fee)"
          >
            <span class="fee-list-label">{{ fee.fee_label }}</span>
            <span class="fee-list-amount">
              {{ fee.paid_amount | number: "1.0" : "hu" }}
              /
              {{ fee.original_amount | number: "1.0" : "hu" }}
              {{ fee.currency_iso }}
            </span>
            <span
              class="state-badge"
              [class.state-pending]="fee.state === 'pending'"
              [class.state-paid]="fee.state === 'paid'"
              [class.state-refunded]="fee.state === 'refunded'"
            >
              {{ feeStateLabel(fee.state) }}
            </span>
          </button>
        }
        @if (fees().length === 0) {
          <p class="empty-selection">Nincs díj.</p>
        }
      </div>

      <div
        class="fee-form-panel"
        [class.is-submitting]="submitting()"
      >
        @if (selectedFee(); as fee) {
          <form [formGroup]="form">
            <div class="amount-fields">
              <payee-form-field width="max">
                <span payee-label>Eredeti összeg</span>
                <span payee-suffix>{{ fee.currency_iso }}</span>
                <input
                  payee-input
                  type="number"
                  formControlName="original_amount"
                />
                @if (originalAmount.dirty && originalAmount.invalid) {
                  <ng-container payee-error>
                    @if (originalAmount.hasError("required")) {
                      <span>A mező kitöltése kötelező!</span>
                    }
                    @if (originalAmount.hasError("min")) {
                      <span>Az összeg nem lehet negatív.</span>
                    }
                    @if (originalAmount.hasError("max")) {
                      <span>
                        A megadott összeg legfeljebb
                        {{ originalAmount.errors?.max?.max | number: "1.0-0" : "hu" }}
                        {{ fee.currency_iso }} lehet.
                      </span>
                    }
                    @if (originalAmount.hasError("unknown")) {
                      <span>{{ originalAmount.getError("unknown") }}</span>
                    }
                  </ng-container>
                }
              </payee-form-field>

              <div class="amount-copy-buttons">
                <button
                  payee-icon-button
                  color="white"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="copyOriginalToPaid()"
                >
                  <payee-icon
                    name="arrow-down-black"
                    width="14px"
                    height="14px"
                  ></payee-icon>
                </button>
                <button
                  payee-icon-button
                  color="white"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="copyPaidToOriginal()"
                >
                  <payee-icon
                    name="arrow-up-black"
                    width="14px"
                    height="14px"
                  ></payee-icon>
                </button>
              </div>

              <payee-form-field width="max">
                <span payee-label>Befizetett összeg</span>
                <span payee-suffix>{{ fee.currency_iso }}</span>
                <input
                  payee-input
                  type="number"
                  formControlName="paid_amount"
                />
                @if (paidAmountControl.dirty && paidAmountControl.invalid) {
                  <ng-container payee-error>
                    @if (paidAmountControl.hasError("required")) {
                      <span>A mező kitöltése kötelező!</span>
                    }
                    @if (paidAmountControl.hasError("max")) {
                      <span>
                        A megadott összeg legfeljebb
                        {{ paidAmountControl.errors?.max?.max | number: "1.0-0" : "hu" }}
                        {{ fee.currency_iso }} lehet.
                      </span>
                    }
                    @if (paidAmountControl.hasError("unknown")) {
                      <span>{{ paidAmountControl.getError("unknown") }}</span>
                    }
                  </ng-container>
                }
              </payee-form-field>
              <p class="remaining-amount">
                Fennmaradó összeg:
                {{ remainingAmount() | number: "1.0" : "hu" }}
                {{ fee.currency_iso }}
              </p>
              <p
                class="event-net-paid"
                [class.event-net-paid-mismatch]="paidAmountDiffersFromEvents()"
              >
                Események nettó befizetése:
                {{ initialEventNetPaidAmount() | number: "1.0" : "hu" }}
                {{ fee.currency_iso }}
              </p>
            </div>

            <div class="fee-actions">
              @if (canDelete(fee)) {
                <button
                  payee-button
                  color="alert-red"
                  width="max"
                  type="button"
                  [disabled]="submitting()"
                  (click)="deleteSelectedFee()"
                >
                  Törlés
                </button>
              }
              @if (canRecordPayment()) {
                <button
                  payee-button
                  color="white"
                  width="max"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="recordSelectedFeePayment()"
                >
                  @if (isRecordingFullPayment()) {
                    Teljes befizetés rögzítése
                  } @else {
                    Részleges befizetés rögzítése ({{ inferredPaymentAmount() | number: "1.0" : "hu" }} {{ fee.currency_iso }})
                  }
                </button>
              } @else if (canOverpay()) {
                <button
                  payee-button
                  color="white"
                  width="max"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="saveOverpayment()"
                >
                  Túlfizetés rögzítése ({{ inferredOverpaymentAmount() | number: "1.0" : "hu" }} {{ fee.currency_iso }})
                </button>
              } @else if (canRefund(fee)) {
                <button
                  payee-button
                  color="white"
                  width="max"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="refundSelectedFee()"
                >
                  @if (inferredRefundAmount() < initialPaidAmount()) {
                    Részleges visszatérítés ({{ inferredRefundAmount() | number: "1.0" : "hu" }} {{ fee.currency_iso }})
                  } @else {
                    Teljes visszatérítés
                  }
                </button>
              }
              @if (canOverwrite()) {
                <button
                  payee-button
                  color="white"
                  width="max"
                  type="button"
                  [isBorderButton]="true"
                  [disabled]="submitting()"
                  (click)="overwriteSelectedFee()"
                >
                  Felülírás fizetési esemény nélkül
                </button>
              }
            </div>
          </form>
        } @else {
          <p class="empty-selection">
            @if (fees().length === 0) {
              Még nincs díj az ügyön. Adjon hozzá egyet a termék díjai közül.
            } @else {
              Válasszon egy díjat a szerkesztéshez.
            }
          </p>
        }

        @if (submitting()) {
          <div class="submitting-overlay">
            <mat-progress-spinner
              mode="indeterminate"
              color="accent"
            ></mat-progress-spinner>
          </div>
        }
      </div>
    </div>

    @if (addableFees().length > 0 || fees().length === 0) {
      <div class="add-fee-section">
        <h3>Díj hozzáadása</h3>
        @if (addableFees().length === 0) {
          <p class="empty-selection">Minden termék díj hozzá van adva.</p>
        }
        @if (addableFees().length > 0) {
          <div
            class="add-fee-row"
            [formGroup]="addFeeForm"
          >
            <payee-dropdown
              formControlName="fee_id"
              width="max"
              [options]="addableFeeOptions()"
              [displayWith]="addableFeeDisplayWith"
            >
              <span payee-label>Termék díj</span>
              @if (addFeeId.dirty && addFeeId.invalid) {
                <ng-container payee-error>
                  @if (addFeeId.hasError("required")) {
                    <span>A mező kitöltése kötelező!</span>
                  }
                  @if (addFeeId.hasError("unknown")) {
                    <span>{{ addFeeId.getError("unknown") }}</span>
                  }
                </ng-container>
              }
            </payee-dropdown>
            <button
              payee-button
              type="button"
              [disabled]="submitting() || addFeeForm.invalid"
              (click)="addSelectedFee()"
            >
              Hozzáadás
            </button>
          </div>
        }
      </div>
    }
  } @else {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="100"
    ></mat-progress-spinner>
  }

  <ng-template #payeePopupCancelTemplate></ng-template>
</payee-popup>
